import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import Layout from '../../components/layout/Layout';
import useGetCharges from '../../hooks/useGetCharges';
import useGetSubscriptions from '../../hooks/useGetSubscriptions';
import Link from '../../components/common/ui/Link';
import ArrowIcon from '../../assets/icons/common/ArrowIcon';
import { BILLING } from '../../routes';
import ChargeItem from '../../components/common/features/ChargeItem';
import DeviceHomeItem from '../../components/device/DeviceHomeItem';
import Loader from '../../components/common/ui/Loader';
import Button from '../../components/common/ui/Button';
import HomePopupArrowIcon from '../../assets/icons/home/HomePopupArrowIcon';

import styles from './styles.module.scss';

const AMOUNT_OF_SUBS_TO_SHOW = 5;

const Home = () => {
  const [charges, chargesLoading] = useGetCharges({
    status: 'queued',
    include: 'payment_methods',
  });
  const [chargesTitle, setChargesTitle] = useState(
    'No payments for the next 20 days.',
  );
  const [subscriptions, subscriptionsLoading] = useGetSubscriptions();
  const [showAllSubs, setShowAllSubs] = useState(false);
  const [sliceSubAmount, setSliceSubAmount] = useState(AMOUNT_OF_SUBS_TO_SHOW);
  const [hidePopup, setHidePopup] = useState(
    localStorage.getItem('hide_homepage_popup'),
  );

  const showAllSubscriptions = () => {
    setShowAllSubs(true);
    setSliceSubAmount(subscriptions.length);
  };

  const hidePopupHandle = () => {
    setHidePopup(true);
    localStorage.setItem('hide_homepage_popup', true);
  };

  useEffect(() => {
    if (charges.length > 0) {
      setChargesTitle('Upcoming Charge');
    }
  }, [charges]);

  const showLoader = subscriptionsLoading || chargesLoading;
  const showCharges = charges.length > 0;

  if (showLoader) {
    return (
      <Layout className={cn(styles.home, styles.homeLoading)}>
        <Loader show={true} />
      </Layout>
    );
  }
  return (
    <Layout className={styles.home}>
      <div className={styles.homeCharges}>
        <div className={styles.homeChargesTop}>
          <h3 className={styles.homeChargesTitle}>
            {chargesTitle}
            {showCharges && '*'}
          </h3>
          <Link
            to={BILLING}
            colorType="orange"
            className={styles.homeChargesLink}
          >
            <span> Billing History</span> <ArrowIcon></ArrowIcon>
          </Link>
        </div>
        {showCharges ? (
          <>
            <ul className={styles.homeChargesList}>
              {charges.map((charge, index) => (
                <li key={index}>
                  <ChargeItem chargeInfo={charge}></ChargeItem>
                </li>
              ))}
            </ul>
            <p className={cn('text-s', styles.homeChargesNote)}>
              *Charges displayed excludes taxes. You may see a different charge
              amount on your account once the payment is processed.
            </p>
          </>
        ) : (
          <h2 className={styles.homeChargesNoChargesTitle}>You’re all set!</h2>
        )}
      </div>
      <div className={styles.homeDevices}>
        <h1 className={styles.homeDevicesTitle}>Devices and Subscriptions</h1>
        <h2 className={styles.homeDevicesSubTitle}>Internet and Wi-Fi</h2>
        <ul className={styles.homeDevicesList}>
          {subscriptions.slice(0, sliceSubAmount).map((subscription, index) => (
            <li key={index}>
              <DeviceHomeItem deviceData={subscription}></DeviceHomeItem>
            </li>
          ))}
        </ul>
        {!showAllSubs && subscriptions.length > AMOUNT_OF_SUBS_TO_SHOW && (
          <div className={styles.homeDevicesAllDevicesBtn}>
            <Button colorType="grey" onClick={showAllSubscriptions}>
              Show all {subscriptions.length} devices
              <ArrowIcon></ArrowIcon>
            </Button>
          </div>
        )}
      </div>
      <div
        className={cn(styles.homePopup, {
          [styles.hidePopup]: hidePopup,
        })}
      >
        <HomePopupArrowIcon></HomePopupArrowIcon>
        <p>
          You can view your data <br /> usage here in the <br /> Devices & Plans
          page
        </p>
        <Button
          onClick={hidePopupHandle}
          className={styles.homePopupButton}
          colorType="white"
        >
          Dismiss
        </Button>
      </div>
    </Layout>
  );
};

export default Home;
